<template>
    <div class="apprentice-simple-card">
        <div
            class="not-found with-header"
            v-if="lessonModules.length === 0">
            <div
                class="btn-add-circle icon"
                @click="showCreateModal"></div>
            <div class="alert-notice">{{ $t('lesson_module.no_lesson_modules_found') }}</div>
        </div>

        <!--    todo should become cards-->
        <design-2021-apprentice-data-table
            v-else
            :items="lessonModulesComputed"
            :fields="fields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-lesson-module"
                    @click="showCreateModal()"
                    :title="$t('lesson_module.add')"
                    variant="primary-icon">
                    {{ $t('lesson_module.add') }}
                </b-button>

                <b-button class="btn-edit btn-edit-types" variant="primary-icon" @click="openTypesModal">{{ $t('lesson_module.manage_types')}}</b-button>
            </template>
            <template #cell(actions)="data">
                <div class="row-actions">
                    <b-button
                        class="btn-open btn-open-lesson-module remove-icon-margin"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('lesson_module.open')"
                        @click="openLessonModule(data.item)">
                    </b-button>
                    <b-button
                        class="btn-edit btn-edit-lesson-module remove-icon-margin"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('lesson_module.edit')"
                        @click="openEditModal(data.item)">
                    </b-button>
                    <b-button
                        class="btn-copy btn-copy-lesson-module remove-icon-marging"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title-="$t('common.copy')"
                        @click="openCopyModal(data.item)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-badge"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('lesson_module.delete')"
                        @click="removeLessonModule(data.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-create-lesson-module-modal-component
            ref="create-lesson-module-modal"
            :lesson-module-types-in="types"
            @lesson-module-added="addLessonModule">
        </design-2021-create-lesson-module-modal-component>
        <design-2021-edit-lesson-module-modal-component
            :lesson-module-types-in="types"
            ref="edit-lesson-module-modal"
            @lesson-module-updated="updateLessonModule">
        </design-2021-edit-lesson-module-modal-component>
        <design-2021-copy-lesson-module-modal-component
            :lesson-module-types-in="types"
            ref="copy-lesson-module-modal"
            @lesson-module-added="addLessonModule">
        </design-2021-copy-lesson-module-modal-component>
        <design-2021-lesson-module-types-modal
            :lesson-module-types-in="types"
            ref="lesson-module-types-modal"
            @types-updated="typesUpdated">
        </design-2021-lesson-module-types-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-organization-lesson-module-index-component',
    props: {
        lessonModulesIn: {
            type: Array,
        },
        lessonModuleTypesIn: {
            type: Array,
        }
    },
    data() {
        return {
            lessonModules: this.lessonModulesIn,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'type_name',
                    label: this.$t('common.type'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            types: this.lessonModuleTypesIn,
        };
    },
    computed: {
        lessonModulesComputed() {
            return this.lessonModules.map((module) => {
                module.type_name = module.type?.name ?? null
                return module;
            })
        }
    },
    methods: {
        openLessonModule(lessonModule) {
            window.location.href = this.routes.lessonModuleShow(lessonModule.id);
        },
        showCreateModal() {
            this.$refs['create-lesson-module-modal'].show();
        },
        openEditModal(lessonModule) {
            this.$refs['edit-lesson-module-modal'].show(lessonModule);
        },
        openCopyModal(lessonModule) {
            this.$refs['copy-lesson-module-modal'].show(lessonModule);
        },
        addLessonModule(lessonModule) {
            this.lessonModules.push(lessonModule);
            this.alert.success();
        },
        updateLessonModule(lessonModule) {
            this.lessonModules = this.lessonModules.map((lessonModuleOld) => {
                if (lessonModuleOld.id === lessonModule.id) {
                    return lessonModule;
                }
                return lessonModuleOld;
            });
            this.alert.success();
        },

        removeLessonModule(lessonModule) {
            this.alert
                .confirm(this.$t('lesson_module.delete'), this.$t('lesson_module.delete_explanation'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.lessonModuleDelete(lessonModule.id)).then(
                            (response) => {
                                this.lessonModules = this.lessonModules.filter(
                                    (lessonModule1) => lessonModule1.id !== lessonModule.id,
                                );
                                this.alert.success();
                            },
                            (error) => {
                                return this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        openTypesModal() {
            this.$refs['lesson-module-types-modal'].show();
        },
        typesUpdated(types) {
            this.types = types;
        }
    },
};
</script>

<style scoped lang="scss">
.btn-add-lesson-module, .btn-edit-types {
    line-height: 1.5;
    margin-left: 8px;
}
.row-actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
}
</style>
